import React from 'react';

export default function FormBox({children}) {
  return (
    <div className="form-container">
      <div className="text-center">
        <div className="decs-card mt-4">
          <div className="card-body col-sm-12 text-label-left desc-card-body">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

